(function() {
  const BREAKPOINT = 1280; // ← modifiez selon vos besoins

  function enableHoverMenus() {
    if (window.innerWidth < BREAKPOINT) return;

    document.querySelectorAll('.header__menu-disclosure').forEach(details => {
      if (details.dataset.hoverBound) return;
      details.dataset.hoverBound = true;
      details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
      details.addEventListener('mouseleave', () => details.removeAttribute('open'));
    });
  }

  // On attend que le thème soit prêt
  document.addEventListener('DOMContentLoaded', enableHoverMenus);
  window.addEventListener('resize', enableHoverMenus);
})();